import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html, body {
    font-family: 'Roboto', sans-serif;
    font-size: 10px;
    height: 100%;
    overflow-x: hidden;
  }

  #root {
    height: 100%;
  }

  p {
    margin: 0;
  }

  .customPosition {
    top: 50%;
    transform: translateY(-50%);
    right: 24px;

    > div {
      border: 1px solid #E3E6EC;
      border-radius: 16px;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
    }

    .Toastify__close-button {
      position: absolute;
      top: 0;
      right: 0;

      width: 48px;
      height: 48px;
    }

    @media (max-width: 767px) {
      position: static;
      transform: none;
      /* 100vw counts the scrollbar, so on any viewport that has one this element is wider
         than its container. Being position: static it is in flow, so that overflows the page
         horizontally — hidden by the overflow-x rule above, but still enough to shift
         fixed-position overlays sideways. */
      width: 100%;
      padding: 0;

      > div {
        border-radius: 0;
        box-shadow: none;
        border: none;
        background-color: #F8F9FA;
      }
    }
  }

  // custom toast transitions

  .slide-in-bottom {
	-webkit-animation: slide-in-bottom 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	        animation: slide-in-bottom 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  @-webkit-keyframes slide-in-bottom {
    0% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }

    50% {
      opacity: 0.3;
    }
    
    100% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-in-bottom {
    0% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
  }

  .slide-out-bottom {
	-webkit-animation: slide-out-bottom 0.3s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
	        animation: slide-out-bottom 0.3s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
  }
  
  @-webkit-keyframes slide-out-bottom {
    0% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }
  }

  @keyframes slide-out-bottom {
    0% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }
  }

  @media (max-width: 576px) {
    .intercom-lightweight-app-launcher {
      bottom: 130px !important;
    }
  }

  /* Getting Started (dark) — design-system dark input variant, ported from the
     website contract-flow (.sc-dark-field). Same structure as the light DS input
     (1.5px border, 8px radius, purple focus ring) on a dark surface. */
  .sc-dark-field {
    width: 100%;
    /* Explicit height: without it this came from the 48px height on "form input"
       in global.scss — right by accident, and gone if the screen stops being a form. */
    height: 48px;
    border-radius: 8px;
    border: 1.5px solid rgba(255, 255, 255, 0.14);
    background-color: #2b2a3a;
    padding: 14px 16px;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #ffffff;
    outline: none;
  }

  .sc-dark-field::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }

  .sc-dark-fieldset {
    border-radius: 8px;
    border: 1.5px solid rgba(255, 255, 255, 0.14);
    background-color: #2b2a3a;
  }

  .sc-dark-field:focus,
  .sc-dark-fieldset:focus-within {
    outline: none;
    border-color: #5968db;
    box-shadow: 0 0 0 3px rgba(89, 104, 219, 0.4);
  }

  .sc-dark-field[aria-invalid='true'],
  .sc-dark-fieldset[data-invalid='true'] {
    border-color: rgba(255, 154, 154, 0.7);
    background-color: rgba(255, 154, 154, 0.1);
  }

  /* Explicit padding/height: global.scss declares 16px padding and 48px height for
     "form input" and "form select". Since Getting Started became a form, that rule
     reaches this input. Without this the phone box inflates, because here (unlike
     .sc-dark-field) the surrounding fieldset provides the spacing, not the input. */
  .sc-dark-input-bare {
    width: 100%;
    min-width: 0;
    height: auto;
    padding: 0;
    border: none;
    background: transparent;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #ffffff;
    outline: none;
  }

  .sc-dark-input-bare::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }

  .sc-dark-field:-webkit-autofill,
  .sc-dark-input-bare:-webkit-autofill {
    -webkit-text-fill-color: #ffffff;
    -webkit-box-shadow: 0 0 0 1000px #2b2a3a inset;
    caret-color: #ffffff;
  }

`;

export default GlobalStyles;
